export const LeaveVI = {
  "reasonLeave": {
    "title": "Lý do xin nghỉ",
    "breadCrumb": "Quản lý lý xin nghỉ",
    "pageHeader": {
      "reasonLeave": "Quản lý lý do xin nghỉ"
    }
  }
}
